var ResourcesSelector = function(){

    'use strict';

    var $ = jQuery;    var instances = [];


    function onReady() {
        $('.module.resources-selector').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id');

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // instance object
        var instance = {
            init: function () {
                
            }
        };

        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

ResourcesSelector();

